export const accountNavigation = {
    account: {
        name: 'Account',
        href: '/members/account'
    },
    profile: {
        name: 'Profile',
        href: '/members/account/profile'
    },
    contact: {
        name: 'Contact',
        href: '/members/account/contact'
    },
    payments: {
        name: 'Account Billing',
        href: '/members/account/payments'
    },
    communicationPreferences: {
        name: 'Communication Preferences',
        href: '/members/account/communication-preferences'
    },
    emailPassword: {
        name: 'Email & Password',
        href: '/members/account/email-password'
    },
    history: {
        name: 'Transaction History',
        href: '/members/account/transaction-history'
    },
    certification: {
        name: 'CKA® Designation',
        href: '/members/account/certification'
    },
    reCertification: {
        name: 'Recertification',
        href: '/members/account/certification/recertification'
    },
    apply: {
        name: 'Apply',
        href: '/members/account/certification/apply'
    },
    ce: {
        name: 'CE Credit',
        href: '/members/account/ce'
    },
    champions: {
        name: 'Champions',
        href: '/members/account/champions'
    }
};
